import { heading, subHeading, getRelativeFontSize, mediumFont, PrimaryTextColor, regularFont, boldFont } from "../../../../../utils/styles";

const ViewEmployeeDocumentsStyles = {
    contentWrapper: {
        padding: "0 50px",
      },

      pageInfoHeader: {
        position: "absolute",
        left: "130px",
        top: "30px",
      },
    
      Heading: {
        ...boldFont,
        fontSize: getRelativeFontSize(10),
      },
    
      text: {
        ...regularFont,
        color: PrimaryTextColor,
        fontSize: getRelativeFontSize(-2),
      },
    
      heading: {
        ...heading,
      },
    
      subHeading: {
        ...subHeading,
      },
    
      contentHeaderLeft: {
        display: "flex",
        alignItems: "start",
        juatifyContent: "start",
        width: "100%",
        flexDirection: "column",
      },
    
      contentHeaderRight: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
      },
    
      detailsHeading: {
        ...heading,
        fontSize: getRelativeFontSize(2),
      },
    
      userLabal: {
        ...mediumFont,
        fontSize: getRelativeFontSize(0),
        color: PrimaryTextColor,
      },
    
      userDetails: {
        color: "#0C0E2E",
        fontSize: getRelativeFontSize(2),
        ...regularFont,
        marginTop: "5px",
      },
    
      avtarInfo: {},
    
      avtarImg: {
        width: "65px",
        height: "65px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      },
      profileDetails: {
        marginTop: "20px",
      },
      buttonWarapper: {
        display: "flex",
        marginTop: "50px",
        gap: "20px",
      },
}


export default ViewEmployeeDocumentsStyles;